var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoPause({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 50,
    viewBox: "0 0 45 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 5.55555C0 2.48731 2.4624 0 5.49992 0H10.9998C14.0374 0 16.4998 2.48731 16.4998 5.55556V44.4444C16.4998 47.5127 14.0374 50 10.9998 50H5.49992C2.4624 50 0 47.5127 0 44.4444V5.55555Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.502 5.55555C27.502 2.48731 29.9644 0 33.0019 0H38.5018C41.5393 0 44.0017 2.48731 44.0017 5.55556V44.4444C44.0017 47.5127 41.5393 50 38.5018 50H33.0019C29.9644 50 27.502 47.5127 27.502 44.4444V5.55555Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPause);
export default __webpack_public_path__ + "static/media/video_pause.1fc6680d121a6f6970f96266d17d9405.svg";
export { ForwardRef as ReactComponent };